import { IonButton, IonIcon } from "@ionic/react";
import { closeSharp } from "ionicons/icons";

interface PhotoCardProps {
  photo: {
    url: string;
    description?: string;
  };
  onDelete: () => void;
}

export const PhotoCard: React.FC<PhotoCardProps> = ({ photo, onDelete }) => {
  return (
    <div className="tw:relative">
      <img
        src={photo.url}
        alt={photo.description || "Photo"}
        className="tw:w-full tw:h-24 tw:object-cover tw:rounded"
      />
      <IonButton
        size="small"
        color="transparent"
        className="tw:absolute tw:top-0 tw:right-0"
        onClick={onDelete}
      >
        <IonIcon
          icon={closeSharp}
          color="white"
          className="tw:drop-shadow-sm tw:drop-shadow-black"
        />
      </IonButton>
    </div>
  );
};
